<template>
    <v-dialog v-model="shows" max-width="860">
        <template #activator="{ attrs, on }">
            <slot name="default" v-bind="{ attrs, on }" />
        </template>
        <v-card class="v-card--dialog">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">상품권 번호 목록</h3>
                <v-btn fab color="transparent" @click="exit" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="v-card--dialog__body page-text text-center">
                <nshop-order-view-pins v-bind="{ value }" />
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { initNshopOrder } from "@/store/nshop";

import NshopOrderViewPins from "../../nshop/order/nshop-order-view-pins.vue";

export default {
    components: {
        NshopOrderViewPins,
    },
    props: {
        value: { type: Object, default: initNshopOrder },
    },
    data: () => ({
        shows: false,
    }),
    computed: {},
    methods: {
        exit() {
            this.shows = false;
        },
    },
};
</script>

<style lang="scss" scoped></style>
